export default __webpack_public_path__ + "static/truncation-do-6c202818009498d77ba20fa6c15b89c4.png";